import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import Common from "../../../../helper/common";
import {
  ImageFolderEnum,
  respEnum,
} from "../../../../constants/appConstant";
import { Formik } from "formik";
import { Icon } from "@iconify/react";
import {
  FormikInput,
  FormikSearchSelect,
  FormikSingleFileUpload,
  FormikSwitch,
} from "../../../../components/formik-components";
import { Button } from "../../../../components/ui/button";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  isactive: true,
};

const formikValidation = yup.object({
  name: yup.string().trim().min(3).max(30).required("Name is Required"),
})
// title: yup.string().trim().min(3).max(30).required("Title is Required"),
const AddOpenMatchClub = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const [clubAccountList, setClubAccountList] = useState([]);

  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      getClubAccount();
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  // const handelSliderType = () => {

  //   setSliderType()
  // };
  const getClubAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubsDDL"
      );
      const data = [
        {
          id: null,
          name: "No Club",
        },
        ...response.data,
      ];
      setClubAccountList(data);
    });
  };

  // const preparePayload = (rawData) => {
  //   const banner = rawData.files?.find((f) => f.path)?.path || null;

  //   return {
  //     clubid: rawData.clubid,
  //     createdby: rawData.createdby,
  //     createdon: rawData.createdon,
  //     id: rawData.id,
  //     banner: banner,
  //     isactive: rawData.isactive,
  //     isdeleted: rawData.isdeleted,
  //     title: rawData.title,
  //     type: rawData.type,
  //     updatedby: rawData.updatedby,
  //     updatedon: rawData.updatedon,
  //   };
  // };


  const onSubmitData = async (d, action) => {
    debugger;

    const imagePath = d.files?.[0].path;
    if (imagePath) {
      d.logo = imagePath;
    }

    if (d.files && d.files.filter((item) => !item.imageUrl).length) {
      var uploadFilePathType = ImageFolderEnum.upload;
      d.logo = (
        await Common.Utility.handleFileUpload(d.files, uploadFilePathType)
      )[0].photo;
      d.files = null;
    } else if (d.attachment) {
      d.logo = d.logo;
    }

    let data = {
      ...d,
      id,
    };

    data.name = !data.name ? null : data.name;

    debugger;
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateOpenMatchClub",
      data,
      "POST"
    );

    // if (response.status === respEnum.Success) {
    //   Common.SweetAlert.alert(response.message, "success");
    //   setTimeout(() => {
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/openmatchclub", { replace: true });
      }
    }
    //     }
    //   });
    // }


  };

  // const handleDateChange = (value) => {
  //   const humanDate = new Date(value).toLocaleDateString("en-US", {
  //     year: "numeric",
  //     month: "long",
  //     day: "numeric",
  //   });
  //   setFromDate(humanDate);
  // };

  // function toStandardDateFormat(dateString) {
  //   const date = new Date(dateString); // input like "07/09/2025 12:00 AM"
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}-${month}-${day}`;
  // }

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetOpenMatchClub?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {

      const item = response.data[0];
      formikRef.current.setValues({
        ...item,
        id: item.id,
        name: item.name,           // actual club name
        clubId: item.clubId ?? null,
        logo: item.logo ?? null,
        isactive: item.isactive,
      });
    }
  };
  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Open Match Club
            </DialogTitle>
          </DialogHeader>
          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <FormikInput
                        formikProps={formikProps}
                        name={"name"}
                        label={"Name*"}
                        placeholder={"Club Name"}
                        maxLength="50"
                      />
                      <div className="flex flex-col gap-2">
                        <div className="col-span-3">
                          <FormikSingleFileUpload
                            formikProps={formikProps}
                            title={"logo"}
                            uploadMainTxt={"Upload Image"}
                            uploadTxt={"Max size 2 MB "}
                            name={"logo"}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col gap-3">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"clubId"}
                          placeholder={"Select"}
                          label={"Linked Club (Optional)"}
                          data={clubAccountList}
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <FormikSwitch
                          formikProps={formikProps}
                          // disabled={id}   //toggle ko disabled karne k leye update karte wqt
                          name={"isactive"}
                          label={"Is Active"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                    ? "Add"
                    : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddOpenMatchClub;
